import { calcSpacing } from 'src/components/foundations';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const SectionContainer = styled.div<{ $isInitialState?: boolean }>`
  margin-bottom: ${({ $isInitialState }) =>
    $isInitialState ? '0' : `${calcSpacing(2.5)}px`};
`;

export const LanguageVariantsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  position: relative;
`;

export const LanguageVariantWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${calcSpacing(0.8)}px;
  width: 100%;
`;

export const LanguagesControlRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${calcSpacing(1)}px;
  width: 100%;
`;

export const LanguageDropdownContainer = styled.div`
  flex: 1;
  min-width: 0;
  position: relative;
  z-index: 100;
`;

export const LanguageVariantLabel = styled.label`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const InitialStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${calcSpacing(5)}px;
`;

export const InitialStateIllustration = styled.img`
  width: 160px;
  height: 132px;
  display: block;
  margin-bottom: ${calcSpacing(3.5)}px;
`;

export const InitialStateTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${calcSpacing(3.5)}px;
  align-items: center;
  margin-bottom: ${calcSpacing(2)}px;
`;

export const InitialStateTitle = styled.h2`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
  text-align: center;
`;

export const InitialStateDescription = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 0;
  text-align: center;
  max-width: 522px;
`;

export const LoadingStateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 500px;
`;

export const LanguageDropdownWrapper = styled.div`
  width: 100%;
  margin-top: ${calcSpacing(1)}px;
`;
